import { useLocation } from "react-router-dom";
import { headerLogoLinkDisabledRoutes } from "@/helpers/const";
import { mfoTheme } from "@/mfo-themes";
import { env } from "~/env";

export const LogoLink = () => {
  const location = useLocation();
  const isLink = !headerLogoLinkDisabledRoutes.includes(
    location.pathname as (typeof headerLogoLinkDisabledRoutes)[number]
  );
  const Tag = isLink ? "a" : "div";
  const props = isLink ? { href: env.VITE_ROOT_URL } : {};

  const isWelcomePage = location.pathname === "/welcome";
  const logoToUse =
    isWelcomePage && mfoTheme.assets.logoWelcomeUrl
      ? mfoTheme.assets.logoWelcomeUrl
      : mfoTheme.assets.logoUrl;
  const logoMdToUse =
    isWelcomePage && mfoTheme.assets.logoWelcomeUrl
      ? mfoTheme.assets.logoWelcomeUrl
      : mfoTheme.assets.logoMdUrl;

  return (
    <Tag {...props} className="logo">
      <img src={logoToUse} alt="logo" className="md-hide" />
      <img src={logoMdToUse} alt="logoMD" className="md-visible" />
    </Tag>
  );
};
